window.toastStack = function () {
    return {
        toasts: [],
        init() {
            document.addEventListener('toast:add', event => {
                this.addToast(event.detail.message, event.detail.type || 'success');
            });
        },
        addToast(message, type) {
            const id = Date.now() + Math.random();
            const toast = {id, message, type};
            this.toasts.push(toast);

            setTimeout(() => this.removeToast(id), 4000);
        },
        removeToast(id) {
            this.toasts = this.toasts.filter(t => t.id !== id);
        }
    }
}
